import "./AlreadyPurchasedModal.scss";
import images from "../../utilities/images/images";

const AlreadyPurchasedModal = ({paymentModal, setPaymentModal}) => {
    const closeModal = () => {
        setPaymentModal(false);
    };
    return (
        <>
        {paymentModal && <div className="modal_wrapper text-center align-items-center">
            <div className="modal_inner">
                <button onClick={closeModal}><img src= {images.close_btn} alt="close" /></button>
                <p>You have already purchased this course</p>
            </div>
        </div>}
        </>
    );
}

export default AlreadyPurchasedModal;